<template>
    <span class="devegram-input-label-field">{{(translate) ? $ml.get(label): label}}</span>
</template>

<script>
export default {
  props: {
    label: {
      required: true
    },
    translate: {
      required: false,
      default: true
    }
  }
}
</script>
